import { render, staticRenderFns } from "./VersionsHistory.vue?vue&type=template&id=1a609d9a&"
import script from "./VersionsHistory.vue?vue&type=script&lang=js&"
export * from "./VersionsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports